
<mvs-widget *ngIf="contractLabelWidget"
            [widgetData]="contractLabelWidget">
</mvs-widget>
